var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserMaster(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1746_6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.15625 9.375C6.83899 9.375 8.20312 8.01087 8.20312 6.32812C8.20312 4.64538 6.83899 3.28125 5.15625 3.28125C3.47351 3.28125 2.10938 4.64538 2.10938 6.32812C2.10938 8.01087 3.47351 9.375 5.15625 9.375Z",
    stroke: "#495057",
    strokeWidth: 0.9375,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.10547 3.39258C9.37481 3.31953 9.65257 3.2821 9.93164 3.28125C10.7397 3.28125 11.5147 3.60226 12.0861 4.17366C12.6575 4.74506 12.9785 5.52004 12.9785 6.32812C12.9785 7.13621 12.6575 7.91119 12.0861 8.48259C11.5147 9.05399 10.7397 9.375 9.93164 9.375",
    stroke: "#495057",
    strokeWidth: 0.9375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.9375 11.5663C1.41325 10.8893 2.04494 10.3367 2.77922 9.95529C3.5135 9.57383 4.3288 9.37469 5.15625 9.37469C5.9837 9.37469 6.799 9.57383 7.53328 9.95529C8.26756 10.3367 8.89925 10.8893 9.375 11.5663",
    stroke: "#495057",
    strokeWidth: 0.9375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.93164 9.375C10.7592 9.37449 11.5746 9.57338 12.309 9.95484C13.0433 10.3363 13.675 10.8891 14.1504 11.5664",
    stroke: "#495057",
    strokeWidth: 0.9375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1746_6"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserMaster);
export default __webpack_public_path__ + "static/media/User Master.2cffc09003d79cb7ebb9588ebf10a897.svg";
export { ForwardRef as ReactComponent };